import { newAxiosIns } from '@/libs/axios'

export default function apiReadFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return newAxiosIns.post('document/read_file', formData)
}
